import { render, staticRenderFns } from "./create-question.component.html?vue&type=template&id=02cc20dc&scoped=true&external"
import script from "./create-question.component.ts?vue&type=script&lang=ts&external"
export * from "./create-question.component.ts?vue&type=script&lang=ts&external"
import style0 from "./create-question.component.scss?vue&type=style&index=0&id=02cc20dc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cc20dc",
  null
  
)

export default component.exports